import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskUnassignedTicketTypeFieldsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-unassigned-ticket-type-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?',
};
